import _ from 'lodash';

/**
 * Converts any object's camelCase keys to snake_case for logging.
 * Example: { firstName: "John" } -> { first_name: "John" }
 */
export const convertObjToSnakeCase = (context: object): Record<string, any> => {
  return _.mapKeys(context, (value, key) => _.snakeCase(key));
};
